import { render, staticRenderFns } from "./goal_list.vue?vue&type=template&id=1e0c04af"
import script from "./goal_list.vue?vue&type=script&lang=js"
export * from "./goal_list.vue?vue&type=script&lang=js"
import style0 from "./goal_list.vue?vue&type=style&index=0&id=1e0c04af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports